export default __webpack_public_path__ + "static/media/descargar-arrow-white.a6f46cc9.svg";